import React, { PropTypes } from 'react'
import Parallax from '../Parallax'
import FriendItem from './FriendItem'
import BottomNavigation from '../BottomNavigation'

import { ROUTE_HIRING, ROUTE_MEDIA } from '../../constants'
import { FRIENDS } from "../../data";

function Friends() {

  return (
    <div>
      <Parallax image="friends" alt="Amis" title="Amis" />

      <ul className="collection">
        {FRIENDS.map(friend => <li key={friend.name} className="collection-item avatar friend-card"><FriendItem friend={friend}/></li>)}
      </ul>

      <Parallax image="hiring" alt="Recrutement" />
      <BottomNavigation previousText="Médias" previousLink={ ROUTE_MEDIA } nextText="Recrutement" nextLink={ ROUTE_HIRING } />

    </div>
  )

}

Friends.propTypes = {
  friends: PropTypes.array
}

export default (Friends)



/** WEBPACK FOOTER **
 ** ./src/components/Friends/Friends.jsx
 **/